import { cn } from '@/lib/utils';

import { Spinner } from './ui/spinner';

export type AbsoluteLoaderProps = {
	className?: string;
	children?: React.ReactNode;
	isLoading: boolean;
};
export function AbsoluteLoader({ className, children, isLoading = false }: AbsoluteLoaderProps) {
	if (!isLoading) {
		return null;
	}
	return (
		<div className={cn('absolute inset-0 bg-background/50 flex items-center justify-center z-10', className)}>
			{children ? children : <Spinner className="h-1/4 w-1/4 text-foreground" />}
		</div>
	);
}
